export default {
  shape: `<path fill="#000" fill-opacity=".98" d="m7.4 14.7-.7-.7L12 8.7l5.3 5.3-.7.7-4.6-4.6-4.6 4.6Z"/>`,
  viewBox: [0, 0, 24, 24],
};
